// extracted by mini-css-extract-plugin
export default {"container":"KI-z","error":"LI-z","disabled":"MI-z","submit":"NI-z","option":"OI-z","success":"PI-z","failure":"QI-z"};